import { Navigate, RouteObject } from "react-router-dom";
import SidebarLayout from "./layouts/SidebarLayout";
import BaseLayout from "./layouts/BaseLayout";
import { useContext } from "react";
import { SidebarContext } from "./contexts/SidebarContext";
import Home from "./pages/dashboard/components/home/home";
// import EmailVerification from "./pages/emailVerification/components";
import ResetPasswordForm from "./pages/password/resetPassword/components";
import ForgotPasswordForm from "./pages/password/forgotPassword/components";
import Login from "./pages/authentication";
import SidebarLayout2 from "./layouts/SidebarLayout/SideBarLayout2";
// import NullPage from "./shared/components/NullPage";
import Dashboard from "./pages/dashboard/components/dashboard";
import Logout from "./pages/authentication/components/logOut";

let appRoutes: RouteObject[];

const Router = () => {
  const { routes } = useContext(SidebarContext);

  appRoutes = [
    {
      path: "",
      element: <BaseLayout />,
      children: [
        {
          path: "",
          element: <Home />,
        },
        {
          path: "/login",
          element: <Login />,
        },
        {
          path: "/logout",
          element: <Logout />,
        },

        // {
        //   path: "/verify-email/:id",
        //   element: <EmailVerification />,
        // },
      ],
    },
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPasswordForm />,
    },
    {
      path: "/reset-password/:id",
      element: <ResetPasswordForm />,
    },
    // {
    //   element: <SidebarLayout />,
    //   children: [{ path: "/global-admin", element: <NullPage /> }],
    // },
    {
      element: <SidebarLayout2 />,
      children: routes?.concat([
        {
          path: "*",
          element: <Navigate to="" replace />,
        },
      ]),
    },
  ];

  return appRoutes;
};

export default Router;
